import { useEffect } from "react";
import moment from "moment";

import {
	defaultAnswerType,
	backendTypeToAnswerType,
	answerTypeMap,
	questionTypeToBackendType,
} from "../constants/answerType";
import { useSelector } from "react-redux";

const useSavedValuesFromBackend = (setFieldsValue, getFieldDecorator) => {
	const voting = useSelector((store) => store.votingStore.voting);
	useEffect(() => {
		const setValues = {};
		setValues.title = voting.title;
		setValues.description = voting.text;
		setValues.period = [moment(voting.dateStart), moment(voting.dateStop)];
		if (voting.addresses) {
			Object.entries(voting.addresses).forEach(([index, value]) => {
				if (value !== null) {
					getFieldDecorator(`addresses[${index}]`, {
						initialValue: false,
					});
					setValues[`addresses[${index}]`] = value;
				}
			});
		}
		if (voting.attachments) {
			getFieldDecorator(`file`, {
				initialValue: {
					file: voting.attachments[voting.attachments.length - 1],
					fileList: voting.attachments,
				},
			});
		}
		if (voting.questions) {
			getFieldDecorator(`questionsKeys`, {
				initialValue: "0",
			});
			setFieldsValue({
				questionsKeys: voting.questions
					.map((question) => question.id)
					.join(","),
			});
			voting.questions.filter(Boolean).forEach((question) => {
				getFieldDecorator(`questions[${question.id}].title`, {
					initialValue: "",
				});
				setValues[`questions[${question.id}].title`] = question.text;
				getFieldDecorator(`questions[${question.id}].answerKeys`, {
					initialValue: "0",
				});
				setFieldsValue({
					[`questions[${question.id}].answerKeys`]: question.answers
						.filter((answer) => {
							return answer.type.id !== answerTypeMap.writing;
						})
						.map((answer) => answer.id)
						.join(","),
				});
				getFieldDecorator(`questions[${question.id}].answerType`, {
					initialValue: defaultAnswerType,
				});
				setValues[`questions[${question.id}].answerType`] =
					backendTypeToAnswerType[question.type.id];
				getFieldDecorator(`questions[${question.id}].obligatory`, {
					initialValue: false,
					valuePropName: "checked",
				});
				setValues[`questions[${question.id}].obligatory`] = question.obligatory;
				getFieldDecorator(`questions[${question.id}].haveOtherOption`, {
					initialValue: false,
				});
				if (
					question.type.id !== questionTypeToBackendType.text &&
					question.answers.some((answer) => {
						return answer.type.id === answerTypeMap.writing;
					})
				) {
					setValues[`questions[${question.id}].haveOtherOption`] = true;
				}
				if (question.files.length > 0) {
					getFieldDecorator(`questions[${question.id}].files`, {
						initialValue: question.files,
					});
				}
				if (question.answers) {
					question.answers
						.filter((answer) => {
							return answer.type.id !== answerTypeMap.writing;
						})
						.forEach((answer) => {
							getFieldDecorator(
								`questions[${question.id}].answers[${answer.id}].text`,
								{
									initialValue: false,
								}
							);
							setValues[
								`questions[${question.id}].answers[${answer.id}].text`
							] = answer.name;
							if (answer.files.length > 0) {
								getFieldDecorator(
									`questions[${question.id}].answers[${answer.id}].files`,
									{
										initialValue: answer.files,
									}
								);
							}
						});
				}
			});
			setFieldsValue(setValues);
		}
	}, [voting]);
};

export default useSavedValuesFromBackend;
